import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 20, className = "" }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Stagger = ({ children, className = "", delay = 0 }) => (
    <motion.div
        className={className}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-50px" }}
        variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.08, delayChildren: delay } },
        }}
    >
        {children}
    </motion.div>
);

export const Item = ({ children, className = "", y = 16 }) => (
    <motion.div
        variants={{
            hidden: { opacity: 0, y },
            show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } },
        }}
        className={className}
    >
        {children}
    </motion.div>
);

export default Reveal;
